import LoaderDirective from './LoaderDirective';
import ProgressDirective from './ProgressDirective';
import VisuallyHiddenDirective from './VisuallyHiddenDirective';
import 'portalConfig';

export default angular.module('edge.platform.widgets.loadingMsg', ['portal.config'])
    .directive('gwLoader', LoaderDirective)
    .directive('gwProgress', ProgressDirective)
    .directive('gwVisuallyhiddenUnless', VisuallyHiddenDirective);
